import {
  ToggleBlockType
} from './block-type'

export class HeaderThree extends ToggleBlockType {
  getBlockType = () => 'header-three'

  getButtonText = () => 'H3'
}



/** WEBPACK FOOTER **
 ** ./lib/toggle/block-type/header-three.js
 **/